<section class="vc-admin-entity-detail">
  <app-admin-page-header
    titleKey="ADMIN.TREATMENTS.ALL.CATEGORIES"
    descriptionKey="ADMIN.IA.TREATMENTS.DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    contextLabelKey="COMMON.NAME"
    [contextValue]="category?.name || ''"
  ></app-admin-page-header>

  <div class="vc-admin-entity-detail__content">
    @if (loading) {
      <app-admin-state-panel mode="loading" titleKey="COMMON.LOADING"></app-admin-state-panel>
    } @else if (hasError || !category) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.TREATMENTS.CATEGORIES.ERROR.LOAD"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else {
      <app-admin-form-layout>
        <app-form-category-treatments
          [payload]="category"
          [showIntro]="false"
          [onUpdate]="reload"
        ></app-form-category-treatments>
      </app-admin-form-layout>
    }
  </div>
</section>
